import { PageHeading } from "@/components/common/PageHeading.tsx";
import { PatchUserDto } from "@/models";
import { useStore } from "@/stores/useStore.ts";
import { LoadingPage } from "@/components/page/LoadingPage.tsx";
import { useToast } from "@/hooks/useToast.tsx";
import { user } from "@/repositories/user.ts";
import { EditUserForm } from "@/components/forms/EditUser.form.tsx";
import { useState } from "react";
import { Button } from "@/components/base/Button.tsx";

export const UserProfilePage = () => {
  const userData = useStore((s) => s.user);
  const { toast } = useToast();
  const [isEditable, setIsEditable] = useState(false);

  if (!userData) {
    return <LoadingPage />;
  }

  const handleOnSubmit = async (values: PatchUserDto) => {
    await user.update(values).then(() => {
      toast({
        title: "Profile Updated!",
        description: `Your profile was updated successfully.`,
      });
    });
    return;
  };

  const handleCancel = async () => {
    setIsEditable(false);
  };

  return (
    <div className="flex flex-col gap-4 m-auto p-4">
      <div className="flex flex-row space-between pb-4">
        <PageHeading>User Profile</PageHeading>
        <div className="flex-grow" />
        {!isEditable && (
          <Button onClick={() => setIsEditable(!isEditable)}>Edit</Button>
        )}
      </div>
      <EditUserForm
        onSubmit={handleOnSubmit}
        onCancel={handleCancel}
        initialUserData={userData}
        isEditable={isEditable}
      />
    </div>
  );
};
